import { IOrganization, IPasswordRuleOverride } from '../types/interfaces';

export const MINIMUM_PASSWORD_EXPIRATION_DAYS = 60;

export const PASSWORDS_MATCH_CONSTRAINT = 'Password fields must match';

export const DEFAULT_PASSWORD_RULES: IPasswordRuleOverride[] = [
  { constraint: 'At least one capital letter', regex: '[A-Z]' },
  {
    constraint: 'At least one special character',
    regex: '[!@#$%^&*\\(\\)_\\-+=~`\\[\\]\\{\\}\\|:;"\'<>,.?\\\\\\/]', //[!@#$%^&*\(\)_\-+=~`\[\]\{\}\|:;"'<>,.?\\\/]
  },
  { constraint: 'Minimum of 8 characters', regex: '^.{8,}$' },
];

export function getPasswordRules(
  organization?: Pick<IOrganization, 'passwordRuleOverrides'>,
): IPasswordRuleOverride[] {
  const rules = organization?.passwordRuleOverrides?.length
    ? organization.passwordRuleOverrides
    : DEFAULT_PASSWORD_RULES;

  return [...rules, { constraint: PASSWORDS_MATCH_CONSTRAINT, regex: '' }];
}

export interface IPasswordRuleValidationResult {
  constraint: string;
  valid: boolean;
}

export function validatePasswordAgainstRules(
  password: string,
  confirmedPassword: string,
  rules: IPasswordRuleOverride[],
): IPasswordRuleValidationResult[] {
  return rules.map(({ constraint, regex }) => ({
    constraint,
    valid:
      constraint === PASSWORDS_MATCH_CONSTRAINT
        ? password === confirmedPassword
        : new RegExp(regex).test(password),
  }));
}

export interface IPasswordValidationStatus {
  valid: boolean;
  results: IPasswordRuleValidationResult[];
}

export function isPasswordValid(
  password: string,
  confirmedPassword: string,
  rules: IPasswordRuleOverride[],
): IPasswordValidationStatus {
  const results = validatePasswordAgainstRules(
    password,
    confirmedPassword,
    rules,
  );

  return {
    valid: results.every((result) => result.valid),
    results,
  };
}
